import colors from './colors';
export default {
  hover: "0 0 0 2px ".concat(colors.hoverHalo),
  focus: "0 0 0 2px ".concat(colors.focusHalo),
  active: "0 0 0 4px ".concat(colors.activeHalo)
};
//# sourceMappingURL=halos.js.map